var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import { Grid } from "react-bootstrap";
import { FormattedMessage } from "@irati/utils/lang";
import ghost from "@irati/ui/images/circle_ghost.svg";
import { StyledCard, StyledH2, Picture } from "./styled";
var Div = function (props) { return React.createElement("div", __assign({}, props)); };
var MobileDisabled = /** @class */ (function (_super) {
    __extends(MobileDisabled, _super);
    function MobileDisabled() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileDisabled.prototype.render = function () {
        var useGrid = this.props.useGrid;
        var Wrapper = useGrid ? Grid : Div;
        return (React.createElement(Wrapper, null,
            React.createElement(StyledCard, null,
                React.createElement(Picture, { src: ghost }),
                React.createElement(StyledH2, null,
                    React.createElement(FormattedMessage, { id: "platform.components.mobile.headerTwo" })))));
    };
    MobileDisabled.defaultProps = {
        useGrid: true
    };
    return MobileDisabled;
}(PureComponent));
export default MobileDisabled;
